// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utils
const { formatText } = require('core/i18n').i18n;
// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

require('./sendPinByMailStep1.scss');

class sendPinByMailStep1 extends React.Component {

    render() {
        const {address,beneficiaryName,immCards} = this.props;
        const cardNumber = immCards.get('number');
        let cardCurrent = immCards.getIn([ 'alias', 'current' ]);
        cardCurrent = cardCurrent ? cardCurrent.toUpperCase() : cardCurrent;
        const PinHeader = formatText('sendPinByMailStep1-reenvío');
        const PinSubtext = formatText('sendPinByMailStep1-PinSubtext');
        const confirmAdd1 = formatText('sendPinByMailStep1-confirmAdd1');
        const confirmAdd2 = formatText('sendPinByMailStep1-confirmAdd2');
        const confirmAdd3 = formatText('sendPinByMailStep1-confirmAdd3',[cardCurrent]);
        const confirmAdd4 = formatText('sendPinByMailStep1-confirmAdd4');
        const questionMark=formatText('sendPinByMailStep1-questionMark');
        return (
            <section className="step-container">
                <div className="send-pin-by-mail-step1">
                    <div className="container-keyscc__header">
                        <h4 className="wizard-step--vertical__title">
                            {PinHeader}
                        </h4>
                        <p className="wizard-step--vertical__sub-title">{PinSubtext}</p>
                    </div>
                    <BlockInfo extraClass="send-pin-by-mail-step1__large-box">
                        <p>{confirmAdd1}
                            <span className="send-pin-by-mail-step1__address-text--uppercase">{beneficiaryName}
                            </span>
                        </p>
                        <p>{confirmAdd2}
                            <span className="send-pin-by-mail-step1__address-text">{address}
                            </span>
                        </p>
                        <p>{confirmAdd3}
                            <span className="send-pin-by-mail-step1__address-text">{cardNumber}
                            </span>
                        </p>
                        <p>{confirmAdd4}
                            <span className="send-pin-by-mail-step1__address-text--uppercase">{beneficiaryName}
                            </span>
                            {questionMark}
                        </p>
                    </BlockInfo>
                </div>
            </section>
        );
    }
}

sendPinByMailStep1.propTypes = {
    address: PropTypes.string.isRequired,
    beneficiaryName: PropTypes.string.isRequired,
    immCards: PropTypes.object.isRequired
};

module.exports = sendPinByMailStep1;
